import React, { useEffect, useState } from 'react'

//interfaces
import { ITableColumn, ITableContent, ITableRows } from  '@/interfaces/simpleTable';
import { IDraftRecords } from  '@/interfaces/draftData';
import { NotificationStatus } from  '@/interfaces/languages';

//components
import ContentImageAndName from  '@/components/elements/content/ContentImageAndName';

//utils 
import { hideFromUI } from  '@/helpers/xframework';

//api
import { getDraftItems, getMoreDraftItems, publishItems } from '@/api/drafts';




const UseDraftsScreen = (appId: string) => {  
    const [tableContent, setTableContent] = useState<ITableContent>();
    const [draftData, setDraftData] = useState<IDraftRecords[]>();
    const [top, setTop]=useState<number>(0);
    const [skip, setSkip]=useState<number>(0);
    const [total, setTotal]=useState<number>(0);
    const [moreAvailable, setMoreAvailable]=useState<boolean>(false);
    const [isLoading, setIsLoading]=useState<boolean>(true);
    const [showSimpleTable, setShowSimpleTable] = useState<boolean>(false);
    const [notificationDetails, setNotificationDetails] = useState<{show: boolean, status: NotificationStatus, message: string}>({show: false, status: NotificationStatus.null, message: ""});
    const pageTitle = "Drafts"
    const publishAllButton = "Publish All";
    const publishAllButtonLabel = "Publish all the draft content";
    const columns: ITableColumn[] = [{ title: "Title", isToggleButton: false }];
    const noDataMessage = "There are no drafts"
    const disablePublishAll : boolean = (!total) || (total === 0);

    useEffect(() => {
        /* X-frame work troubles */
        // react drafts template doesn't have all the knockout required to control flat picker
        // we need to hide it for the draft page, otherwise it renders on the screen in a very
        // unslightly way!.
        hideFromUI(document.querySelector('.flatpickr-calendar.hasTime.animate') as HTMLDivElement)
        hideFromUI(document.querySelector('.archive-flatpickr')as HTMLDivElement)
        hideFromUI(document.querySelector('.panelGroup.widgetPanels') as HTMLDivElement)

        const mainContentPanel = document.querySelector('.mainContentPanel.panel') as HTMLDivElement;

        if (mainContentPanel) {
            mainContentPanel.style.width = '816px';
        }
    },[]);

    
    useEffect(() => {
        getAllDrafts();
    },[])

    useEffect(() => {
        let rows: ITableRows[] = [];
        draftData?.forEach((draft) => {
            const row: ITableRows = {
                content: [<ContentImageAndName key={draft.id} image={draft.featuredImageUrl} contentId={draft.id} contentTitle={draft.title} contentType={draft.contentType} truncate={80}/>], 
                controls: [{content:"Publish", onClick:() => onPublishDraftItemClick(draft.id)}]
            };
            rows.push(row);
        });
 
        setTableContent({rows: rows, columns: columns});
        setShowSimpleTable(true);
    }, [draftData])

    useEffect(() => {
        if (notificationDetails.show) {
            const timer = setTimeout(() => {
                setNotificationDetails({show: false, status:NotificationStatus.null, message: ""});
            }, 3000);

            return () => clearTimeout(timer);
        }
    }, [notificationDetails]);

    function getAllDrafts(){
        setIsLoading(true);
        getDraftItems(appId)
        .then(({top, total, records, moreAvailable}) => {
            setDraftData(records);
            setTop(top);
            setSkip(top);
            setTotal(total);
            setMoreAvailable(moreAvailable)
        })
        .finally(() => {
            setIsLoading(false);
        });
    }

    function updateDrafts(){
        if (!moreAvailable){
           return
        }
        getMoreDraftItems({appId, skip, top})
        .then(({skip, records, moreAvailable}) => {
            setDraftData((prevDraftData) => [...(prevDraftData || []), ...records]);
            setSkip(skip + top);
            setMoreAvailable(moreAvailable)
        });
    }

    function onPublishDraftItemClick(contentId:number) {
        const payload = {contentIds: [contentId]};

        publishItems(appId, payload)
        .then(() =>{ 
           setNotificationDetails({show: true, status: NotificationStatus.success, message:"Successfully published item"});
        })
        .catch(() => {
            failureNotification();
        })
        .finally(() => {
            getAllDrafts();   
        })
    }
    
    function onPublishAllDrafts() {
        if (!draftData) return;

        const contentIds: number[] = draftData.map(draft => draft.id);
        const payload = {contentIds: contentIds};

        publishItems(appId, payload)
        .then(() =>{ 
           setNotificationDetails({show: true, status: NotificationStatus.success, message:"Successfully published items"});
        })
        .catch(() => {
            failureNotification();
        })
        .finally(() => {
            getAllDrafts();   
        })
    }    

    function failureNotification(){
        setNotificationDetails({show: true, status: NotificationStatus.error, message:"Something went wrong. Please try again."});
    }

    

    return{ pageTitle, publishAllButton, publishAllButtonLabel, showSimpleTable, tableContent, onPublishAllDrafts, noDataMessage, updateDrafts, notificationDetails, disablePublishAll, moreAvailable, isLoading}
}

export default UseDraftsScreen